import React, { useContext } from "react";
// import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { CardContext } from "../../../store/CardContext";
import { useQueryClient } from "@tanstack/react-query";
import { updateTapCount } from "../../../helpers/tapCountMutation";

const defaultProfileImage =
  "https://zeeqr-files.s3.ap-south-1.amazonaws.com/assets/defaultProfile.jpg";
function ProfileCardGlassy({ preview }) {
  const [cardData] = useContext(CardContext)
  const { profileImage, personalDetails, checkProfile, vCard, contactDetails } = cardData


  const array = personalDetails?.name ? personalDetails?.name?.split(" ") : "";

  const handleShare = () => {
    if (navigator.share && preview) {
      navigator
        .share({
          text: "Please check it out.",
          url: window.location.href,
          title: "ZEEQR",
        })
        .then(() => console.log("Successful share"))
        .catch((error) => console.log("Error sharing", error));
    }
  };

  /* ------------------ tap count taking using tanstack query ----------------- */

  const queryClient = useQueryClient();

  const handleTap = (button) => {
    // console.log("iiii");

    updateTapCount(queryClient, button);
  };

  return (
    <div className="flex justify-between bg-[#D9D9D933] items-center rounded p-3 m-[15px]">
      {/* {checkProfile ? (
        <div className="rounded-[8px] overflow-hidden">
          {profileImage[0]?.thumbUrl &&
          profileImage[0]?.status !== "removed" ? (
            <img
              className="w-[150px] m-w-[150px] rounded-[8px]"
              src={
                profileImage[0]?.originFileObj?.type
                  ? URL.createObjectURL(profileImage[0]?.originFileObj)
                  : profileImage[0].thumbUrl
              }
              alt=""
            />
          ) : (
            <img src={defaultProfileImage} alt="" className="w-[150px] m-w-[150px] rounded-[8px]" />
          )}
        </div>
      ) : (
        ""
      )} */}
      <div className="justify-start flex items-center ml-0  text-white">
        <div>
          <h1
            style={{
              width: `${!checkProfile ? "max-content" : ""}`,
              fontSize: `${array[0]?.length > 12 ||
                array[1]?.length > 12 ||
                array[2]?.length > 12
                ? "30px text-white"
                : "30px text-white"
                }`, lineHeight: "30px"
            }}
          >
            {" "}
            {personalDetails?.name ? personalDetails.name : "Name"}
          </h1>
          <p className="text-[16px] text-white">
            {personalDetails?.companyDesignation
              ? personalDetails.companyDesignation
              : "Designation"}
          </p>

        </div>
      </div>
      <div className="m-0 ">
        {/* <div className="flex justify-center items-center pb-2">
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="30" height="30" rx="4" fill="white" />
            <rect width="18" height="18" transform="translate(6 6)" fill="white" />
            <path d="M17.8125 17.8125H20.625V20.625H17.8125V17.8125ZM15.5625 15.5625H17.8125V17.8125H15.5625V15.5625ZM20.625 20.625H22.875V22.875H20.625V20.625ZM21.1875 15.5625H22.875V17.25H21.1875V15.5625ZM15.5625 21.1875H17.25V22.875H15.5625V21.1875ZM17.8125 9.375H20.625V12.1875H17.8125V9.375Z" fill="black" />
            <path d="M22.875 14.4375H15.5625V7.125H22.875V14.4375ZM17.1094 12.8906H21.3281V8.67188H17.1094V12.8906ZM9.375 9.375H12.1875V12.1875H9.375V9.375Z" fill="black" />
            <path d="M14.4375 14.4375H7.125V7.125H14.4375V14.4375ZM8.67188 12.8906H12.8906V8.67188H8.67188V12.8906ZM9.375 17.8125H12.1875V20.625H9.375V17.8125Z" fill="black" />
            <path d="M14.4375 22.875H7.125V15.5625H14.4375V22.875ZM8.67188 21.3281H12.8906V17.1094H8.67188V21.3281Z" fill="black" />
          </svg>

        </div> */}
        <div className="flex items-center justify-center">
          <Link
            onClick={() => handleTap('saveContact')}
            to={`${preview ? vCard : ""}`}
            // target={`${preview ? "_blank" : ""}`}
            className="blk-btn w-100"
          >
            <button className="bg-transparent gap-2 w-100 flex justify-center items-center ">
              <div>
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_2_11)">
                    <path d="M11 9.59479V5.59479H9V9.59479H5V11.5948H9V15.5948H11V11.5948H15V9.59479H11ZM10 20.5948C7.34784 20.5948 4.8043 19.5412 2.92893 17.6659C1.05357 15.7905 0 13.247 0 10.5948C0 7.94262 1.05357 5.39908 2.92893 3.52372C4.8043 1.64836 7.34784 0.594788 10 0.594788C12.6522 0.594788 15.1957 1.64836 17.0711 3.52372C18.9464 5.39908 20 7.94262 20 10.5948C20 13.247 18.9464 15.7905 17.0711 17.6659C15.1957 19.5412 12.6522 20.5948 10 20.5948Z" fill="white" />
                  </g>
                  <defs>
                    <clipPath id="clip0_2_11">
                      <rect width="20" height="20" fill="white" transform="translate(0 0.594788)" />
                    </clipPath>
                  </defs>
                </svg>

              </div>

              <p className="text-[14px] font-medium text-white  m-0 flex justify-center items-center2">
                Add to contacts
              </p>
            </button>
          </Link>
        </div>
      </div>
      {/* <div className="flex gap-2">
            <div className="flex gap-2 h-[40px] border-r cursor-pointer border-black justify-center items-center" onClick={handleShare}>
              <button className="transparent border-black border p-2 rounded-[8px]">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 18 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 20C14.1667 20 13.4583 19.7083 12.875 19.125C12.2917 18.5417 12 17.8333 12 17C12 16.8833 12.0083 16.7623 12.025 16.637C12.0417 16.5117 12.0667 16.3993 12.1 16.3L5.05 12.2C4.76667 12.45 4.45 12.646 4.1 12.788C3.75 12.93 3.38333 13.0007 3 13C2.16667 13 1.45833 12.7083 0.875 12.125C0.291667 11.5417 0 10.8333 0 10C0 9.16667 0.291667 8.45833 0.875 7.875C1.45833 7.29167 2.16667 7 3 7C3.38333 7 3.75 7.071 4.1 7.213C4.45 7.355 4.76667 7.55067 5.05 7.8L12.1 3.7C12.0667 3.6 12.0417 3.48767 12.025 3.363C12.0083 3.23833 12 3.11733 12 3C12 2.16667 12.2917 1.45833 12.875 0.875C13.4583 0.291667 14.1667 0 15 0C15.8333 0 16.5417 0.291667 17.125 0.875C17.7083 1.45833 18 2.16667 18 3C18 3.83333 17.7083 4.54167 17.125 5.125C16.5417 5.70833 15.8333 6 15 6C14.6167 6 14.25 5.92933 13.9 5.788C13.55 5.64667 13.2333 5.45067 12.95 5.2L5.9 9.3C5.93333 9.4 5.95833 9.51267 5.975 9.638C5.99167 9.76333 6 9.884 6 10C6 10.1167 5.99167 10.2377 5.975 10.363C5.95833 10.4883 5.93333 10.6007 5.9 10.7L12.95 14.8C13.2333 14.55 13.55 14.3543 13.9 14.213C14.25 14.0717 14.6167 14.0007 15 14C15.8333 14 16.5417 14.2917 17.125 14.875C17.7083 15.4583 18 16.1667 18 17C18 17.8333 17.7083 18.5417 17.125 19.125C16.5417 19.7083 15.8333 20 15 20Z"
                    fill="black"
                  />
                </svg>
              </button>
              <p className="text-[11px] font-semibold leading-4 w-[29px] mr-[15px] mt-2">
                Share Profile
              </p>
            </div>
            <Link className="flex gap-2 h-[40px] "
                to={`${preview ? contactDetails?.locationUrl : ""}`}
                target={`${preview ? "_blank" : ""}`}
               
              >
            <div className="flex gap-2 justify-center items-center">
              <button className="transparent border-black border p-2 rounded-[8px]">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.53086 1.31436C9.74715 0.752506 9.19507 0.200382 8.63326 0.416693L0.761457 3.44411C0.131565 3.68589 0.181586 4.59282 0.833709 4.7642L4.0809 5.61879C4.14046 5.63443 4.19479 5.66561 4.23833 5.70916C4.28187 5.7527 4.31305 5.80703 4.32869 5.8666L5.18321 9.11357C5.35458 9.7662 6.26144 9.81576 6.5032 9.18629L9.53086 1.31436Z"
                    fill="black"
                  />
                </svg>
              </button>
              <p className="text-[11px] font-semibold  w-[29px] mr-[10px] leading-4 mt-2">
                Get Direction
              </p>
            </div>
            </Link>
          </div> */}


    </div>
  );
}

export default ProfileCardGlassy;
